export const LOCAL_STORAGE_KEY = {
  username: 'user_name',
  fullName: 'full_name',
  userSession: 'user_session',
  modulePermissions: 'module_permissions',
  userSessionList: 'user_session_list',
  removeToken: 'remove_token',
  companyId: 'company_id',
  userType: 'user_type',
  corpPrefix: 'corp_prefix',
  mstMessage: 'mst_message',
  userId: 'user_id',
  handleFirstMenu: 'handle_first_menu',
  cacheLogs: 'cache_logs',
  userPermissions: 'user_permissions',
};
